const normalizeImage = (image, imageBaseUrl) => {
  if (!image) return '';
  return /^https?:\/\//.test(image) ? image : `${imageBaseUrl || ''}${image}`;
};

const toMoney = value => Math.round(Number(value || 0) * 100) / 100;

/**
 * 满赠弹窗同时表达两个档位：
 * - progressTier：下一档，用于进度条和“还差多少”；
 * - currentGoods：当前已命中档，告诉用户现在实际获得什么；
 * - nextGoods：下一档，告诉用户继续凑单后将升级为什么。
 */
const buildGiftProgressData = (giftInfo, giftTotalPrice, imageBaseUrl = '') => {
  if (!giftInfo || (!giftInfo.next && !giftInfo.now)) return null;

  const hasCurrentGift = !!giftInfo.now;
  const unlocked = !giftInfo.next && hasCurrentGift;
  const progressTier = giftInfo.next || giftInfo.now;
  const currentPrice = toMoney(Number(giftTotalPrice || 0) / 100);
  const targetPrice = Number(progressTier.min_price || 0);
  const remainingPrice = unlocked ? 0 : toMoney(Math.max(0, targetPrice - currentPrice));
  const progress = targetPrice > 0 ? Math.min(100, Math.max(0, currentPrice / targetPrice * 100)) : 0;
  const normalizeGoods = tier => tier && tier.goods ? {
    ...tier.goods,
    image: normalizeImage(tier.goods.image, imageBaseUrl)
  } : null;
  const currentGoods = normalizeGoods(giftInfo.now);
  const nextGoods = normalizeGoods(giftInfo.next);

  return {
    hasCurrentGift,
    unlocked,
    currentPrice,
    targetPrice,
    remainingPrice,
    progress,
    content: (giftInfo.now || giftInfo.next).content,
    currentGoods,
    nextGoods
  };
};

module.exports = {
  buildGiftProgressData
};
